import { Table, TableRow, TableCell, Paragraph, TextRun, WidthType, BorderStyle, AlignmentType, TableLayoutType } from 'docx';
import { BORDER_COLOR, HEADER_FILL_COLOR } from './constants';
import { formatDate, DEFAULT_CONTENT_WIDTH, splitWidth } from './utils';
import { turkishToUpper, turkishToLower } from '../../utils/stringUtils';

// İsmin her kelimesinin ilk harfini büyük yapan yardımcı fonksiyon
const capitalizeWords = (string) => {
  return string.split(' ')
    .map(word => turkishToUpper(word.charAt(0)) + turkishToLower(word.slice(1)))
    .join(' ');
};

export const createGeneralInfoTable = (generalInfo, contentWidth = DEFAULT_CONTENT_WIDTH) => {
  const rows = [
    ['Mahkemesi', capitalizeWords(generalInfo.mahkemesi) || ''],
    ['Esas No', generalInfo.esasNo || ''],
    ['Karar No', generalInfo.kararNo || ''],
    ['Karar Tarihi', formatDate(generalInfo.kararTarihi) || ''],
    ['Suç Tarihi', formatDate(generalInfo.sucTarihi) || ''],
    ['Suç/lar', generalInfo.crimes && Array.isArray(generalInfo.crimes) ? generalInfo.crimes.map(s => s.label).join(', ') : ''],
  ];

  const [labelW, valueW] = splitWidth(contentWidth, [0.3, 0.7]);

  return new Table({
    width: { size: contentWidth, type: WidthType.DXA },
    layout: TableLayoutType.FIXED,
    columnWidths: [labelW, valueW],
    borders: {
      top: { style: BorderStyle.SINGLE, size: 1, color: BORDER_COLOR },
      bottom: { style: BorderStyle.SINGLE, size: 1, color: BORDER_COLOR },
      left: { style: BorderStyle.SINGLE, size: 1, color: BORDER_COLOR },
      right: { style: BorderStyle.SINGLE, size: 1, color: BORDER_COLOR },
      insideHorizontal: { style: BorderStyle.SINGLE, size: 1, color: BORDER_COLOR },
      insideVertical: { style: BorderStyle.SINGLE, size: 1, color: BORDER_COLOR },
    },
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({
              children: [new TextRun({
                text: 'GENEL BİLGİLER',
                bold: true,
              })],
              alignment: AlignmentType.CENTER,
            })],
            columnSpan: 2,
            shading: {
              fill: HEADER_FILL_COLOR,
            },
          }),
        ],
      }),
      ...rows.map(([label, value]) => new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({
              children: [new TextRun({
                text: label,
                bold: true,
              })],
            })],
            width: { size: labelW, type: WidthType.DXA },
          }),
          new TableCell({
            children: [new Paragraph({
              children: [new TextRun({
                text: value,
              })],
            })],
            width: { size: valueW, type: WidthType.DXA },
          }),
        ],
      })),
    ],
  });
};